/** @jsxImportSource theme-ui @jsxRuntime classic */
import {
  Flex,
  Container,
  Box,
  Text,
  IntrinsicImage,
  Link,
} from '@tishman/components';
import React from 'react';

import { formatStoryCategory } from '../utils';

interface AtlasMiniFeatureProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: any;
  featured?: boolean;
  children?: React.ReactNode;
}

const AtlasMiniFeature = (props: AtlasMiniFeatureProps): JSX.Element => {
  const { title, alt, formattedPublishAt, url, excerpt, category, image } =
    props.data;

  const formattedCategory = formatStoryCategory(category);

  return (
    <Container
      key={title}
      sx={{
        borderBottom: ['1px solid #F8E9DB', null, null, null, 'none'],
        width: '100%',
        mb: 5,
        maxWidth: [500, null, null, null, 333],
        px: [0, 0],
      }}
    >
      <Flex
        sx={{
          justifyContent: 'space-between',
          alignItems: ['center', null, null, null, 'flex-start'],
          flexDirection: ['column', null, null, null, 'column-reverse'],
          height: '100%',
        }}
      >
        <Box
          sx={{
            flex: ['1 1 auto', null, null, '1 1 40%'],
            textAlign: ['center', null, null, 'left'],
            height: '100%',
            width: '100%',
          }}
        >
          <Flex
            sx={{
              justifyContent: 'space-between',
              alignItems: 'center',
              mt: 3,
              mb: 2,
            }}
          >
            <Link
              sx={{
                variant: 'text.featuredStoryEyebrow',
                mt: 0,
                mb: 0,
                cursor: 'pointer',
                textDecoration: 'none',
              }}
              to={
                props.featured && props.featured === true
                  ? url
                  : `/magazine/#${formattedCategory}`
              }
            >
              {props.featured && props.featured === true
                ? 'Featured Story'
                : category}
            </Link>
            <Text
              sx={{
                mt: 0,
                mb: 0,
              }}
              variant="storyDate"
            >
              {formattedPublishAt}
            </Text>
          </Flex>
          <Link
            sx={{
              'variant': 'text.featuredStoryTitleSmall',
              'fontFamily': 'headingSecondary',
              'textAlign': 'left',
              'display': '-webkit-box',
              'WebkitLineClamp': '3',
              'WebkitBoxOrient': 'vertical',
              'overflow': 'hidden',
              'cursor': 'pointer',
              'textDecoration': 'none',
              '&:hover': { color: 'CREAM', textDecoration: 'underline' },
            }}
            to={url}
          >
            {title}
          </Link>
        </Box>
        <Box
          sx={{
            'flex': ['1 1 auto', null, '1 1 30%'],
            'width': '100%',
            'my': [4, null, null, null, 0],
            'mr': [null, null, null, null, '24px'],
            'cursor': 'pointer',
            '&:hover .atlas-image': {
              transition: 'all 0.5s ease',
              transform: 'scale(1.05)',
              opacity: 0.8,
            },
          }}
        >
          {image && (
            <IntrinsicImage
              alt={alt}
              className="atlas-image"
              image={image}
              onClick={() => (location.href = `${url}`)}
            />
          )}
        </Box>
        <Box
          sx={{
            display: ['block', null, null, null, 'none'],
          }}
        >
          <Text
            mb={[3, null, null, 4]}
            sx={{
              color: '#F8E9DB',
            }}
          >
            {excerpt}
          </Text>
        </Box>
      </Flex>
    </Container>
  );
};

export default AtlasMiniFeature;
